<template>
  <div>
    <draggable
      class="syllable_ul"
      element="ul"
      :list="dataList"
      :options="{group:'title', animation:150}"
      :no-transition-on-drag="true"
      @change="onChange"
    >
      <transition-group type="transition" :name="!drag? 'syll_li' : null" :css="true">
        <div v-for="(item, index) in dataList" :key="rowKey?item[rowKey]:index">
          <slot :record="item" :index="index"></slot>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'CustomDraggingList',

  components: { draggable },
  props: {
    dataList: {
      type: Array,
      default: function() {
        return []
      }
    },
    rowKey: {
      type: String,
      value: ''
    }
  },

  data() {
    return {
      drag: false,
      draggableDataList: []
    }
  },
  watch: {
    'dataList': function(newVal, oldVal) {
      this.draggableDataList = newVal
    }
  },
  mounted() {
    this.draggableDataList = this.dataList
  },
  methods: {
    onChange(evt) {
      this.$emit('draggable', this.draggableDataList)
    }
  }
}
</script>
<style scoped>
ul {
  padding: 0;
}
</style>